"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MobileRow = function (_a) {
    var totalBetAmount = _a.totalBetAmount, date = _a.date, totalWinAmount = _a.totalWinAmount, gameName = _a.gameName, idx = _a.idx;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(idx % 2 === 0 ? styles_module_scss_1.default.odd : '') },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, gameName),
            react_1.default.createElement("div", null),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.date }, date)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.caption },
                " ",
                t('bet')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.caption },
                " ",
                t('win'))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
                    " ",
                    totalBetAmount)),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, totalWinAmount)))));
};
exports.default = MobileRow;
